import React from 'react'
import { ImageScrollWrapper } from './weddings/styles'
import Image from 'next/image'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 10000, min: 1600 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 1600, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 2,
  },
}

const ImageScroll = ({ images }) => {
  return (
    <ImageScrollWrapper>
      <div className="grid-container">
        <Carousel
          draggable={true}
          swipeable={true}
          infinite={true}
          autoPlay={false}
          responsive={responsive}
        >
          {images.map((img, i) => (
            <div key={i} className="wedding-photo-container">
              <Image
                src={img}
                alt="wedding photo"
                priority={true}
              />
            </div>
          ))}
        </Carousel>
      </div>
    </ImageScrollWrapper>
  )
}

export default ImageScroll
